import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { IoCloudDownloadOutline } from 'react-icons/io5';

const PWAInstallButton = () => {
    const { t } = useTranslation();
    const [deferredPrompt, setDeferredPrompt] = useState(null);
    const [showInstallButton, setShowInstallButton] = useState(false);

    useEffect(() => {
        const isStandalone = window.matchMedia('(display-mode: standalone)').matches;
        const isInWebAppiOS = window.navigator.standalone === true;
        const isInstalled = isStandalone || isInWebAppiOS;

        if (isInstalled) {
            setShowInstallButton(false);
            return;
        }

        const handleBeforeInstallPrompt = (e) => {
            e.preventDefault();
            setDeferredPrompt(e);
            setShowInstallButton(true);
        };

        const handleAppInstalled = () => {
            console.log('PWA was installed');
            setShowInstallButton(false);
            setDeferredPrompt(null);
        };

        window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
        window.addEventListener('appinstalled', handleAppInstalled);

        return () => {
            window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
            window.removeEventListener('appinstalled', handleAppInstalled);
        };
    }, []);

    const handleInstallClick = async () => {
        if (!deferredPrompt) {
            return;
        }

        deferredPrompt.prompt();

        const { outcome } = await deferredPrompt.userChoice;
        
        if (outcome === 'accepted') {
            console.log('User accepted the install prompt');
        } else {
            console.log('User dismissed the install prompt');
        }

        setDeferredPrompt(null);
        setShowInstallButton(false);
    };

    if (!showInstallButton) {
        return null;
    }

    return (
        <button
            onClick={handleInstallClick}
            className="fixed top-4 left-20 z-50 flex items-center gap-2 rounded-full border border-cyan-400/40 bg-gradient-to-r from-sky-600 via-cyan-500 to-blue-600 px-3 py-1.5 text-white shadow-lg transition-all duration-200 hover:scale-105 hover:shadow-xl"
            aria-label={t('install_app', 'Install App')}
        >
            <span className="flex h-7 w-7 items-center justify-center rounded-full bg-white/20 backdrop-blur-sm">
                <IoCloudDownloadOutline className="h-3.5 w-3.5" />
            </span>
            <span className="text-xs font-semibold tracking-wide">
                {t('install_app', 'Install App')}
            </span>
        </button>
    );
};

export default PWAInstallButton;
